import { parseDate } from "./parseDate";

export const formatToDDMMYYYY = (
	input: string | number | Date | null | undefined,
): string => {
	if (!input) return "";

	let date: Date;

	// 1️⃣ If already a Date object
	if (input instanceof Date) {
		date = input;
	}
	// 2️⃣ If timestamp (number or numeric string)
	else if (!isNaN(Number(input))) {
		date = new Date(Number(input));
	}
	// 3️⃣ Handle string formats
	else if (typeof input === "string") {
		const parsed = parseDate(input);
		if (parsed) {
			date = parsed;
		} else {
			return "";
		}
	} else {
		return "";
	}

	// 4️⃣ Invalid date safeguard
	if (isNaN(date.getTime())) return "";

	const dd = String(date.getDate()).padStart(2, "0");
	const mm = String(date.getMonth() + 1).padStart(2, "0");
	const yyyy = date.getFullYear();

	return `${dd}/${mm}/${yyyy}`;
};
